module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_15.0c02ca2c.png";